var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogo5(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 60,
    viewBox: "0 0 80 60",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(10,5)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 5,
    y: 5,
    width: 50,
    height: 45,
    fill: "#f0f0f0",
    stroke: "#7a57d1",
    strokeWidth: 2,
    rx: 2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 8,
    y: 10,
    width: 44,
    height: 8,
    fill: "#7a57d1",
    rx: 1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 8,
    y: 23,
    width: 44,
    height: 8,
    fill: "#7a57d1",
    rx: 1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 8,
    y: 36,
    width: 44,
    height: 8,
    fill: "#7a57d1",
    rx: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 14,
    r: 1.5,
    fill: "#50ff50"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 27,
    r: 1.5,
    fill: "#50ff50"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 40,
    r: 1.5,
    fill: "#50ff50"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(25,20)",
    stroke: "#ffffff",
    strokeWidth: 1.5
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 0,
    cy: 0,
    r: 2,
    fill: "#ffffff"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 8,
    cy: -5,
    r: 2,
    fill: "#ffffff"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 8,
    cy: 5,
    r: 2,
    fill: "#ffffff"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 0,
    r: 2,
    fill: "#ffffff"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 2,
    y1: 0,
    x2: 6,
    y2: -5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 2,
    y1: 0,
    x2: 6,
    y2: 5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 10,
    y1: -5,
    x2: 14,
    y2: 0
  }), /*#__PURE__*/React.createElement("line", {
    x1: 10,
    y1: 5,
    x2: 14,
    y2: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo5);
export default __webpack_public_path__ + "static/media/logo5.d3ad34ff0a73da6aff599b570303df45.svg";
export { ForwardRef as ReactComponent };